import React, { Component, PropTypes } from 'react';
import { lang } from '../strings';

export default class Maintenance extends Component {

   render() {
      return (
         <div className="mp-popup-container">
            <div className="mp-popup-content">
               <a href="#" className="mp-close" onClick={this.close}>&times;</a>
               <h2 className="h5 color-dark-blue">{lang.maintenance.title}</h2>
               <p>{lang.maintenance.description}</p>
               <button type="button" className="button" onClick={this.close}>{lang.maintenance.close}</button>
            </div>
         </div>
      );
   }

   close = ev => {
      ev.preventDefault();
      this.props.onClose();
   };
}

Maintenance.propTypes = {
   onClose: PropTypes.func.isRequired
};